export interface FormProps {
  id?: string;
  alertHeader: string;
  alertDescription?: string;
  asyncErrors: SubmissionError[];
  mandatoryLabelDisplayStyle?: DisplayStyle;
  onSubmit: (data: Record<string, unknown>) => void;
  overrideMandatoryMessage?: string;
  showAlertSummary: boolean;
  resetOnSubmit?: boolean;
}

export enum DisplayStyle {
  DEFAULT = 'Default',
  HIDE = 'Hide',
  SHOW = 'Show',
}

export interface SubmissionError {
  name: string;
  message: string;
}
